export const MoreStories = () => {
  return (
    <div className="ui section">
      <h1>More Future Stories</h1>
    </div>
  );
};
